import type { OptionType } from "@/types/common/load-options-types";
import type { Service } from "@/types/services/api-types/service-types";

export function getServiceFormValues(service?: Service) {
  return {
    category: service
      ? ({
          value: service.category_id,
          label: service.category_name,
        } as OptionType | null)
      : (null as OptionType | null),
    name: service?.name ?? "",
    description: service?.description ?? "",
    staff_level: service?.staff_tier_config?.[0]?.staff_level_id?.toString() ?? "1",
    duration: service?.staff_tier_config?.[0]?.duration ?? 15,
    price: service?.staff_tier_config?.[0]?.price ?? "",
  };
}
